import { User } from '../types/user';

export type PermissionAction = 'read' | 'write';

export function userCan(user: User | null | undefined, module: string, action: PermissionAction = 'read'): boolean {
  if (!user) return false;
  const permissions = user.permissions ?? [];
  const entry = permissions.find((perm) => perm.module === module);
  if (!entry) return false;
  if (action === 'write') {
    return Boolean(entry.canWrite);
  }
  return Boolean(entry.canRead) || Boolean(entry.canWrite);
}

